import { useForm } from "react-hook-form";
import { Form, FormItem, FormRow, FormError } from "@/components/form";
import { Flex } from "@/components/flex";
import { Button } from "@/components/button";
import { Loader } from "@/components/loader";
import DatePicker, { registerLocale } from "react-datepicker";
import it from "date-fns/locale/it";
import dayjs from "dayjs";
import { IAuthor } from "@/models/types";
import { useAppDispatch, useAppSelector } from "src/config/store";
import { createAuthor, editAuthor } from "@/reducers/authors-crud.reducer";
import ModalHeader from "@/components/modal/modal-header";
import ModalBody from "@/components/modal/modal-body";
import { validationSchema } from "src/utils/validation-utils";

type Props = {
  author: IAuthor;
};

const AuthorsEdit = (props: Props) => {
  const { author } = props;

  const isEdit = author.ID ? true : false;
  const dispatch = useAppDispatch();
  const authorsCrudState = useAppSelector((state) => state.authorsCrud);

  registerLocale("it", it);

  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    formState: { errors, isValid },
  } = useForm({ mode: "onChange", defaultValues: author });

  const save = (data: IAuthor) => {
    isEdit ? dispatch(editAuthor(data)) : dispatch(createAuthor(data));
  };

  const onChangeDate = (key, value) => {
    setValue(key, value, { shouldValidate: true });
  };

  const formatDateString = (date) => {
    if (!date) {
      return "";
    }
    return dayjs(date).toDate();
  };

  return (
    <>
      <ModalHeader />
      <ModalBody>
        <Form>
          <FormRow>
            <FormItem name="post_title" label={"Nome"}>
              <input
                id="post_title"
                placeholder={"Nome"}
                {...register("post_title", validationSchema.required)}
              />

              {errors.post_title && <FormError error={errors.post_title.message} />}
            </FormItem>
          </FormRow>

          <FormRow>
            <FormItem name="birthPlace" label={"Luogo di nascita"}>
              <input id="birthPlace" placeholder={"Luogo di nascita"} {...register("birthPlace")} />
              {errors.birthPlace && <FormError error={errors.birthPlace.message} />}
            </FormItem>
          </FormRow>

          <FormRow col="2">
            <FormItem name="birthDate" label={"Data di nascita"}>
              <DatePicker
                locale={"it"}
                className=""
                name="birthDate"
                placeholderText={"Data di nascita"}
                dateFormat="dd/MM/yyy"
                autoComplete="off"
                selected={formatDateString(getValues("birthDate"))}
                onChange={(date) => onChangeDate("birthDate", date)}
              />

              <input type="hidden" {...register("birthDate")} />
            </FormItem>

            <FormItem name="deathDate" label={"Data di morte"}>
              <DatePicker
                locale={"it"}
                className=""
                name="deathDate"
                placeholderText={"Data di morte"}
                dateFormat="dd/MM/yyy"
                autoComplete="off"
                selected={formatDateString(getValues("deathDate"))}
                onChange={(date) => onChangeDate("deathDate", date)}
              />
              <input type="hidden" {...register("deathDate")} />
            </FormItem>
          </FormRow>

          <FormRow>
            <FormItem>
              <Flex container alignItems="center">
                <Button
                  className="ml-auto"
                  size="md"
                  color="primary"
                  disabled={!isValid || authorsCrudState.loading}
                  onClick={handleSubmit(save)}
                >
                  {authorsCrudState.loading ? <Loader /> : "Salva"}
                </Button>
              </Flex>
            </FormItem>
          </FormRow>
        </Form>
      </ModalBody>
    </>
  );
};

export default AuthorsEdit;
